import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import { CHOICE_VALUE } from './hbfuller_constants'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'

export default function CaseManagementReportForm() {
  console.log('CaseManagementReportForm rendered:')

  let init = {
    product: CHOICE_VALUE.product.TEC,
    diagnosis: CHOICE_VALUE.currentDiagnosis.mesothelioma,
    plaintiffStatus: CHOICE_VALUE.plaintiffStatus.open,
    dismissalInfo: '',
    gender: '',
    dateAssignedFrom: '',
    dateAssignedTo: '',
    dateClosedFrom: '',
    dateClosedTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('CaseManagementReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('CaseManagementReportForm', navigate, inputs, 'reports.case_management')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit}>
        <div>
          <Table className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='H.B. Fuller Case Management Report' />
            <tbody>
              <CustomSelectListInput label="Product" modelName="HBFuller" entityName="product" name="product" defaultValue={inputs.product} handleChange={handleInputChange} />
              <CustomSelectListInput label="Current Diagnosis" modelName="HBFuller" entityName="injury" name="diagnosis" defaultValue={inputs.diagnosis} handleChange={handleInputChange} />
              <CustomSelectListInput label="Plaintiff Status" modelName="HBFuller" entityName="plaintiff_status" name="plaintiffStatus" defaultValue={inputs.plaintiffStatus} handleChange={handleInputChange} />
              <CustomSelectListInput label="Dismissal Information" modelName="HBFuller" entityName="dismissal_info" name="dismissalInfo" handleChange={handleInputChange} defaultValue={inputs.dismissalInfo} />
              <CustomSelectListInput label="Gender" modelName="HBFuller" entityName="gender" name="gender" handleChange={handleInputChange} defaultValue={inputs.gender} />
              <DateRangeInput label='Date Assigned' name='dateAssigned' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateAssignedFrom} defaultValueTo={inputs.dateAssignedTo} />
              <DateRangeInput label='Date Closed' name='dateClosed' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateClosedFrom} defaultValueTo={inputs.dateClosedTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div >
  )
}